import { api } from "./client";

export const AssetCustomFieldsAPI = {
  list: () => api.get("/asset-custom-fields"),
  create: (payload) => api.post("/asset-custom-fields", payload),
  update: (id, payload) => api.patch(`/asset-custom-fields/${id}`, payload),
  deactivate: (id) => api.delete(`/asset-custom-fields/${id}`),
};
